import Badge from '@/components/ui/Badge';

const STATUS_CONFIG = {
  draft: { label: 'Draft', variant: 'secondary' },
  pending: { label: 'Pending', variant: 'warning' },
  approved: { label: 'Approved', variant: 'success' },
  rejected: { label: 'Rejected', variant: 'destructive' },
  cancelled: { label: 'Cancelled', variant: 'secondary' },
  paid: { label: 'Paid', variant: 'info' },
};

export default function ExpenseStatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.draft;
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
